import Vue from 'vue';

import '@mdi/font/css/materialdesignicons.css';

import App from './App';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/component-library';
import './plugins/date-picker';

Vue.config.productionTip = false;

new Vue( {
    router,
    store,
    vuetify,
    render: ( h ) => h( App ),
} ).$mount( '#app' );
